<template>
  <div class="teachers-wrapper">
    <div class="teacher-banner">
      <img src="/Application/Home/Resource/static/images/mobile/lecturer-banner.png" alt="">
    </div>
    <div class="teacher-menu" ref="teacherMenu">
      <div class="menu-container" :class="{'fixed': controlBarFixed}">
        <div class="search">
          <div class="search-bar" @click="toSearch"><icon icon-class="search"></icon>搜索</div>
        </div>
        <div class="filters-wrapper">
          <div class="teacher-filter-item" :class="{'selected': filterData.nation.length > 0}" @click="openFilter('nation')">
            <div>{{filterData.nation.length > 0 ? filterNationString : '地域'}}</div>
            <span class="filter-icon-arrow"></span>
          </div>
          <div class="teacher-filter-item" :class="{'selected': filterData.major.length > 0}" @click="openFilter('major')">
            <div>{{filterData.major.length > 0 ? filterMajorString : '专业'}}</div>
            <span class="filter-icon-arrow"></span>
          </div>
          <!-- <div class="teacher-filter-item" :class="{'selected': filterData.level.length > 0}" @click="openFilter('level')">
            <div>{{filterData.level.length > 0 ? filterLevelString : '级别'}}</div>
            <span class="filter-icon-arrow"></span>
          </div> -->
          <!-- <div class="teacher-filter-item" :class="{'selected': filterData.service.length > 0}" @click="openFilter('service')">
            <div>{{filterData.service.length > 0 ? filterServiceString : '服务'}}</div>
            <span class="filter-icon-arrow"></span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="teachers-list" v-if="teacherList.length > 0 && !emptyTeacher">
      <lecturer-card v-for="(item, index) in teacherList" :key="index" :item="item"></lecturer-card>
      <div class="load-more">
        <div class="no-more" v-if="noTeacherData">- 没有更多了喔 -</div>
        <div v-else><icon icon-class="loading" class="loading"></icon><span>正在加载更多</span></div>
      </div>
    </div>
    <div class="empty-teacher" v-else>
      <div><img src="/Application/Home/Resource/static/images/mobile/empty-data.png"></div>
      <span>没有相应的讲师</span>
    </div>
    <!-- <router-link to="/lecturer/recommend" class="recommend-float"><img src="/Application/Home/Resource/mini-program-static/new-teacher-icon.gif" alt=""></router-link> -->

    <!-- 讲师筛选浮窗 -->
    <div class="filter-mask" v-if="filterShow" @click="closeFilter">
      <div class="teacher-filter" @click.stop="">
        <div class="filters-wrapper">
          <div class="teacher-filter-item" :class="{'select': currentFilter == 'nation', 'selected': filterData.nation.length > 0}" @click="openFilter('nation')">
            <div>{{filterData.nation.length > 0 ? filterNationString : '地域'}}</div>
            <span class="filter-icon-arrow"></span>
          </div>
          <div class="teacher-filter-item" :class="{'select': currentFilter == 'major', 'selected': filterData.major.length > 0}" @click="openFilter('major')">
            <div>{{filterData.major.length > 0 ? filterMajorString : '专业'}}</div>
            <span class="filter-icon-arrow"></span>
          </div>
          <!-- <div class="teacher-filter-item" :class="{'select': currentFilter == 'level', 'selected': filterData.level.length > 0}" @click="openFilter('level')">
            <div>{{filterData.level.length > 0 ? filterLevelString : '级别'}}</div>
            <span class="filter-icon-arrow"></span>
          </div> -->
          <div class="teacher-filter-item" :class="{'select': currentFilter == 'service', 'selected': filterData.service.length > 0}" @click="openFilter('service')">
            <div>{{filterData.service.length > 0 ? filterServiceString : '服务'}}</div>
            <span class="filter-icon-arrow"></span>
          </div>
        </div>
        <div class="filter-picker-view">
          <div class="filter-list" v-if="currentFilter == 'nation'">
            <div class="filter-item" :class="{'selected': item.selected}" v-for="item in filterNationList" :key="item.num" @click="chooseFilter(item.num, 'nation')">
              <span class="label">{{item.text}}</span>
              <icon icon-class="correct"></icon>
            </div>
          </div>
          <div class="filter-list" v-if="currentFilter == 'major'">
            <div class="filter-item" :class="{'selected': item.selected}" v-for="item in filterMajorList" :key="item.num" @click="chooseFilter(item.num, 'major')">
              <span class="label">{{item.text}}</span>
              <icon icon-class="correct"></icon>
            </div>
          </div>
          <div class="filter-list" v-if="currentFilter == 'level'">
            <div class="filter-item" :class="{'selected': item.selected}" v-for="item in filterLevelList" :key="item.value" @click="chooseFilter(item.value, 'level')">
              <span class="label">{{item.label}}</span>
              <icon icon-class="correct"></icon>
            </div>
          </div>
          <div class="filter-list" v-if="currentFilter == 'service'">
            <div class="filter-item" :class="{'selected': item.selected}" v-for="item in filterServiceList" :key="item.value" @click="chooseFilter(item.num, 'service')">
              <span class="label">{{item.text}}</span>
              <icon icon-class="correct"></icon>
            </div>
          </div>
          <div class="filter-control">
            <button @click="clearFilter" bindtap="clearFilter">重置</button>
            <button class="filter-confirm" @click="closeFilter" bindtap="closeFilter">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .teachers-wrapper{
    .teacher-banner{
      width: 100%;
      height: 1.28rem;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .teacher-menu{
      width: 100%;
      height: 1.08rem;
      .menu-container{
        width: 100%;
        height: 1.08rem;
        &.fixed{
          position: fixed;
          left: 0;
          top: 87px;
          width: 100%;
          background: #FFF;
          z-index: 99;
        }
      }
      .search{
        padding: .12rem;
        .search-bar{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: .36rem;
          background: #F3F3F3;
          color: #999;
          font-size: 14px;
          border-radius: 36px;
          padding: 0 12px;
          svg{
            position: relative;
            top: 1px;
            font-size: 24px;
            margin-right: 4px;
          }
        }
      }
    }

    .teachers-list{
      padding: 12px;
      .load-more {
        height: 60px;
        width: 100%;
        line-height: 60px;
        text-align: center;
        font-size: 14px;
      }

      .load-more span {
        color: #4A4A4A;
      }
      .load-more svg{
        font-size: 14px;
      }
      .load-more .no-more{
        color: #888888;
      }

      @keyframes loading {
        0% {transform: rotate(0deg)}
        50% {transform: rotate(180deg)}
        100% {transform: rotate(360deg)}
      }

      .loading {
        display: inline-block;
        transform-origin: 50% 50%;
        position: relative;
        left: -3px;
        top: -1px;
        animation: loading 1s linear infinite;
      }
    }
    .empty-teacher{
      padding-top: 66px;
      text-align: center;
      font-size: 14px;
      color: #999;
    }
    .empty-teacher img{
      width: 64px;
    }
    .empty-teacher span{
      display: inline-block;
      margin-top: 16px;
      font-size: 14px;
      color: #999;
    }

    .recommend-float{
      position: fixed;
      right: 12px;
      bottom: 0;
      z-index: 10;
      width: 95px;
      img{
        width: 100%;
      }
    }

    .filters-wrapper{
      height: 48px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background: #F9F9F9;
      .teacher-filter-item{
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: #333;
        width: 25%;
        font-size: 14px;
        color: #666;
        &.select{
          color: @cano;
          .filter-icon-arrow{
            border-color: @cano transparent transparent transparent;
          }
        }
        &.selected{
          color: @cano;
          .filter-icon-arrow{
            transform: translateY(-3px);
            border-color: transparent transparent @cano transparent;
            border-style: dashed dashed solid dashed;
          }
        }
        div{
          max-width: 70%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .filter-icon-arrow{
          transform: translateY(2px);
          margin-left: 8px;
          width: 0;
          height: 0;
          border-width: 4px 3px;
          border-color: #CCC transparent transparent transparent;
          border-style: solid dashed dashed dashed;
        }
      }
    }
    .filter-mask{
      position: fixed;
      z-index: 100;
      top: 48px;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
      .filter-view{
        border-bottom: 2rpx solid #EEE;
      }
      .teacher-filter{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
      .filter-picker-view{
        background: #FFF;
        width: 100%;
        .filter-list{
          max-height: 70vh;
          overflow-y: auto;
          .filter-item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 41px 0 43px;
            height: 46px;
            border-bottom: 1px solid #F5F5F5;
            color: #666;
            transition: all .2s ease;
            &.selected{
              color: @cano;
              svg{
                opacity: 1;
              }
            }
            .label{
              font-size: 14px;
            }
            svg{
              font-size: 12px;
              color: @cano;
              opacity: 0;
              transition: opacity .2s ease;
            }
          }
        }
        .filter-control{
          display: flex;
          justify-content: space-between;
          align-items: center;
          button{
            padding: 0;
            width: 50%;
            border: 0;
            background: #FFF;
            height: 48px;
            line-height: 48px;
            font-size: 16px;
            color: #666;
            border-radius: 0;
            transition: all .2s ease;
            &.filter-confirm{
              background: @cano;
              color: #FFF;
            }
          }
        }
      }
    }
  }
</style>

<script>
  import LecturerCard from '@/components/Common/lecturerCard'
  export default {
    data() {
      return {
        controlBarOffset: 0,
        controlBarFixed: false,
        // 一对一老师列表
        teacherList: [],
        teacherPage: 1,
        noTeacherData: false,
        // 老师筛选框显示状态
        filterShow: false,
        // 当前筛选标签
        currentFilter: 'nation',
        // 筛选数据
        filterData: {
          nation: [],
          major: [],
          level: [],
          service: [],
        },
        // 显示筛选文案
        filterNationString: '',
        filterMajorString: '',
        filterLevelString: '',
        filterServiceString: '',
        // 筛选选项
        filterNationList: [],
        filterMajorList: [],
        filterLevelList: [{
          label: '优秀',
          value: 1,
          selected: false
        }, {
          label: '特级',
          value: 2,
          selected: false
        }],
        filterServiceList: [],
        // 筛选结果为空
        emptyTeacher: false,
        // 是否正在加载更多数据
        loadingMoreData: false,
      }
    },
    computed: {

    },
    components: {
      LecturerCard
    },
    created() {
      this.$store.commit('setActiveMenu', 'lecturer');
      // 获取讲师筛选标签
      this.$root.post('/Lecturer/get_lecturer_tags').then(data => {
        data.location.forEach(item => {
          this.$set(item, 'selected', false);
          // item.selected = false;
        })
        data.major.forEach(item => {
          this.$set(item, 'selected', false);
          // item.selected = false;
        })
        data.service.forEach((item, index) => {
          this.$set(item, 'selected', false);
          // item.selected = false;
          // 移除文书深改标签
          if(item.num == 12) {
            data.service.splice(index, 1)
          }
        })
        this.filterNationList = data.location,
        this.filterMajorList = data.major,
        this.filterServiceList = data.service,

        this.getOneononeTeacher();
        this.$nextTick(() => {
          this.getBarOffset();
          $(window).on('scroll',this.scrollHandler);
        })
      })
    },
    beforeDestroy() {
      $(window).off('scroll',this.scrollHandler);
    },
    methods: {
      scrollHandler() {
        let scrollTop = $(document).scrollTop();
        let windowHeight = $(window).height();
        let documentHeight = $(document).height() - 20;
        this.controlBarFixed = (scrollTop + 48 >= this.controlBarOffset) ? true : false;
        // 触底加载更多
        if(scrollTop + windowHeight >= documentHeight && !this.noTeacherData && !this.loadingMoreData) {
          console.log(111)
          this.teacherPage = this.teacherPage + 1;
          this.getOneononeTeacher(this.teacherPage, null, true);
        }
      },
      getOneononeTeacher(page, cb, more = false) {
        if(more) this.loadingMoreData = true;
        this.$root.post('/Lecturer/get_lecturer_list', {
          location: this.filterData.nation.join(','),
          major: this.filterData.major.join(','),
          level: this.filterData.level.length == 2 ? 0 : this.filterData.level.join(','),
          service: this.filterData.service.join(','),
          page: page ? page : 1,
          count: 10,
          search: '',
        }).then(data => {
          console.log(data);
          if(data.status == 0) {
            // 无数据状态
            this.emptyTeacher = true;
            this.noTeacherData = true;
          }else {
            this.emptyTeacher = false;
            // 设置已无加载内容状态
            if (data.is_over == 0) {
              this.noTeacherData = true;
            }
            if(more) {
              this.teacherList = [...this.teacherList, ...data.info];
            }else {
              this.teacherList = data.info;
              this.teacherPage = 1;
              this.noTeacherData = data.is_over == 0 ? true : false;
            }
            this.loadingMoreData = false;
          }
          // 回调
          cb && cb();
        })
      },
      getBarOffset() {
        this.controlBarOffset = this.$refs.teacherMenu.offsetTop;
      },
      // 打开老师筛选浮层
      openFilter(type) {
        this.currentFilter = type;
        this.filterShow = true;
      },
      closeFilter() {
        this.filterShow = false;
      },
      chooseFilter(value, type) {
        switch(type) {
          // 筛选国家
          case 'nation': {
            let list = this.filterData.nation;
            let index = this.filterNationList.findIndex(item => {
              return item.num == value;
            })
            if(list.indexOf(value) == -1) {
              list.push(value);
            }else {
              list.splice(list.indexOf(value), 1)
            }
            this.filterNationList[index].selected = !this.filterNationList[index].selected;
            this.filterData.nation = list;
            // 解析出已选国家的字符串
            let stringArr = [];
            this.filterData.nation.forEach(item => {
              let obj = this.filterNationList.find(stuff => {
                return stuff.num == item
              })
              stringArr.push(obj.text);
            })
            this.filterNationString = stringArr.join(',');
          };break;
          // 筛选专业
          case 'major': {
            let list = this.filterData.major;
            let index = this.filterMajorList.findIndex(item => {
              return item.num == value;
            })
            if(list.indexOf(value) == -1) {
              list.push(value);
            }else {
              list.splice(list.indexOf(value), 1)
            }
            this.filterMajorList[index].selected = !this.filterMajorList[index].selected;
            this.filterData.major = list;
            // 解析出已选专业的字符串
            let stringArr = [];
            this.filterData.major.forEach(item => {
              let obj = this.filterMajorList.find(stuff => {
                return stuff.num == item
              })
              stringArr.push(obj.text);
            })
            this.filterMajorString = stringArr.join(',');
          };break;
          // 筛选等级
          case 'level': {
            let list = this.filterData.level;
            let index = this.filterLevelList.findIndex(item => {
              return item.value == value;
            })
            if(list.indexOf(value) == -1) {
              list.push(value);
            }else {
              list.splice(list.indexOf(value), 1)
            }
            this.filterLevelList[index].selected = !this.filterLevelList[index].selected;
            this.filterData.level = list;
            // 解析出已选级别的字符串
            let stringArr = [];
            this.filterData.level.forEach(item => {
              let obj = this.filterLevelList.find(stuff => {
                return stuff.value == item
              })
              stringArr.push(obj.label);
            })
            this.filterLevelString = stringArr.join(',')
          };break;
          // 筛选服务类型
          case 'service': {
            let list = this.filterData.service;
            let index = this.filterServiceList.findIndex(item => {
              return item.num == value;
            })
            if(list.indexOf(value) == -1) {
              list.push(value);
            }else {
              list.splice(list.indexOf(value), 1)
            }
            this.filterServiceList[index].selected = !this.filterServiceList[index].selected;
            this.filterData.service = list;
            // 解析出已选国家的字符串
            let stringArr = [];
            this.filterData.service.forEach(item => {
              let obj = this.filterServiceList.find(stuff => {
                return stuff.num == item
              })
              stringArr.push(obj.text);
            })
            this.filterServiceString = stringArr.join(',');
          };break;
        }
        // 提交筛选重新获取数据
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        this.getOneononeTeacher(1, () => {
          this.$nextTick(() => {
            $(document).scrollTop(this.controlBarOffset - 48);
            this.$toast.clear();
          })
        })
      },
      // 清除搜索条件
      clearFilter() {
        let clearNation = this.filterNationList.map(item => {
          item.selected = false;
          return item;
        })
        let clearMajor = this.filterMajorList.map(item => {
          item.selected = false;
          return item;
        })
        let clearLevel = this.filterLevelList.map(item => {
          item.selected = false;
          return item;
        })
        let clearService = this.filterServiceList.map(item => {
          item.selected = false;
          return item;
        })
        this.filterData = {
          nation: [],
          major: [],
          level: [],
          service: [],
        }
        this.filterNationString = '';
        this.filterMajorString = '';
        this.filterLevelString = '';
        this.filterServiceString = '';

        this.filterNationList = clearNation;
        this.filterMajorList = clearMajor;
        this.filterLevelList = clearLevel;
        this.filterServiceList = clearService;
        // 提交筛选重新获取数据
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        this.getOneononeTeacher(1, () => {
          this.$toast.clear();
        })
      },
      // 搜索讲师
      toSearch() {
        this.$router.push({path: '/search', query: {type: 3}});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Lecturer/index.vue